import girlReadingImg from "../../assets/girl-reading.svg";
import "./styles.css";
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslationSetup } from "../../utils/useTranslationSetup.js";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import vsCloudTop from "../../assets/vsCloudTop.svg";
import CloudBottom from "../../assets/cloudBottom.svg";
import OnboardInputField from "../../components/OnboardInputField/OnBoardInputField.js";
import InfoIcon from "../../assets/info-icon.svg";
import reverseCloud from "../../assets/reverse-clouds.svg";
import { SCREENS } from "../../utils/CommonUtils/screenConstants.js";

const VSWelcomeScreen = ({
  setActiveScreen,
  audioPermissionStatus,
  locationPermissionStatus,
  setLocationPermissionStatus,
  setLatitude,
  setLongitude,
  setStudentName,
  studentName,
}) => {
  const { t } = useTranslationSetup();

  useEffect(() => {
    if (locationPermissionStatus === "GRANTED" && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          setLocationPermissionStatus("GRANTED");
        },
        () => {
          setLocationPermissionStatus("DENIED");
        }
      );
    } else {
      setLocationPermissionStatus("PROMPT");
    }
  }, [locationPermissionStatus]);

  const handleNavigate = () => {
    if (
      audioPermissionStatus === "GRANTED" &&
      locationPermissionStatus === "GRANTED"
    ) {
      setActiveScreen(SCREENS.RENDER_ASSESSMENT_LANG_SCREEN);
    } else {
      setActiveScreen(SCREENS.RENDER_NEED_PERMISSIONS_SCREEN);
    }
  };

  useEffect(() => {
    setStudentName("");
  }, []);

  return (
    <Box className="welcome-screen">
      <Box className="vs-cloud-top">
        <img src={vsCloudTop} alt="Clouds" className="cloud-top-img" />
      </Box>
      <Box className="reversed-clouds">
        <img src={reverseCloud} alt="Clouds" className="cloud-top" />
      </Box>
      <Box className="grid-container">
        <Box className="vs-welcome-screen-img-container">
          <img
            src={girlReadingImg}
            alt="vs_welcome_screen_img"
            className="vs-welcome-screen-img"
          />
        </Box>
        <Box className="paper-container">
          <Box className="vs-welcome-screen-container">
            <Box className="vs-welcome-screen-heading-text">
              {t("welcome_to_orf")}
            </Box>
            <Box className="vs-welcome-screen-content-wrapper">
              <Box className="vs-welcome-screen-content">
                {t("vs_orf_description")}
              </Box>
            </Box>
          </Box>
          <Box className="vs-onboard-content">
            <Typography className="onboard-text">
              {t("lets_get_on_onboard")}
            </Typography>
            <Box className="onboard-container">
              <OnboardInputField
                studentName={studentName}
                onStudentNameChange={setStudentName}
              />
              <Box
                className={`button-component ${!studentName ? "disabled" : ""}`}
                onClick={studentName ? handleNavigate : null}
              >
                <ArrowForwardIcon className="white-arrow-icon" />
              </Box>
            </Box>
            <Box className="info-container">
              <img src={InfoIcon} alt="info-icon" className="info-icon" />
              <Typography className="info">{t("third_party_info")}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="cloudsBottom">
        <img src={CloudBottom} alt="cloud" />
      </Box>
    </Box>
  );
};

export default VSWelcomeScreen;
